import { DefaultButton, Dropdown, IDropdownOption, ITag, Label, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, Stack, TagPicker } from "@fluentui/react";
import React, { useEffect } from "react";
import { getItem, getItems, updateItem } from "../data/sql";
import { IAssignment } from "../types/IAssignment";
import { IAssignmentTag, IPossibleTag, TagType } from "../types/IAssignmentTags";


const TagConfigurationPanel: React.FunctionComponent<{ assignment: IAssignment, onClose: () => void, onRefresh: () => void }> = ({ assignment, onClose, onRefresh }) => {

    const [currentItem, setCurrentItem] = React.useState<IAssignmentTag>({
        AssignmentPath: assignment.Path,
        Id: -1,
        TagType: "none",
        Tags: []
    });
    const [updatedItem, setUpdatedItem] = React.useState<IAssignmentTag>(currentItem);
    const [possibleTags, setPossibleTags] = React.useState<IPossibleTag[]>([]);
    const [error, setError] = React.useState<any>();
    const [successMessage, setSuccessMessage] = React.useState<string>();
    const [isSaving, setIsSaving] = React.useState(false);

    useEffect(() => {
        getItem("getAssignmentTagMapping", "AssignmentPath", assignment.Path).then(assignmentTagMapping => {
            let tagMapping: IAssignmentTag = { ...assignmentTagMapping, Id: assignmentTagMapping.AssignmentTagId}
            if (assignmentTagMapping?.TagType) {
                setCurrentItem(tagMapping);
                setUpdatedItem(tagMapping);
            }
        }).catch(err => {
            setError(err)
        });
    }, [])

    useEffect(() => {
        getItems("getListOfExistingTags").then(tags => {
            setPossibleTags(tags);
        })
    }, [updatedItem])

    const options: IDropdownOption[] = [{ key: "none", text: "None" }, { key: "single", text: "Only One" }, { key: "multiple", text: "Multiple" }];

    return <Panel isOpen={true}
        type={PanelType.medium}
        onDismiss={onClose}
        isFooterAtBottom={true}
        onRenderFooterContent={() => {
            return <Stack tokens={{ childrenGap: 6 }}>
                {error && <MessageBar messageBarType={MessageBarType.error}>{error.message || error}</MessageBar>}
                {successMessage && <MessageBar messageBarType={MessageBarType.success}>{successMessage}</MessageBar>}
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                    {!successMessage && updatedItem && <PrimaryButton text='Submit' disabled={JSON.stringify(updatedItem) === JSON.stringify(currentItem) || isSaving} onClick={() => {
                        setIsSaving(true)
                        updateItem("updateAssignmentTagMapping", updatedItem).then(res => {
                            if (res.Prefix === "RequestError") {
                                setError(JSON.stringify(res));
                            }
                            else {
                                setSuccessMessage(`Successfully ${updatedItem.Id === -1 ? "created" : "updated"} assignment tag configuration`);
                            }
                            setIsSaving(false)
                        }).catch((err: any) => setError(err));
                    }} />}
                    <DefaultButton text={successMessage ? "Close" : "Cancel"} onClick={onClose} />
                </Stack></Stack>
        }}
        headerText={currentItem?.Id === -1 ? `New Assignment Tag Configuration` : `Modify Assignment Tag Configuration`}>
        <Dropdown
            label="Tag Option"
            options={options}
            selectedKey={updatedItem?.TagType}
            disabled={successMessage ? true : false}
            onChange={(_ev, option) => {
                setUpdatedItem({ ...updatedItem, TagType: option?.key.toString() as TagType || "none" });
            }} />
        {updatedItem.TagType && updatedItem.TagType !== "none" && <Stack>
            <Label>{updatedItem.TagType === "single" ? "Tag" : "Tags"}
            </Label>
            <TagPicker
                disabled={successMessage ? true : false}
                selectedItems={updatedItem?.Tags?.map(t => ({ key: t, name: t }))}
                itemLimit={updatedItem.TagType === "single" ? 1 : undefined}
                onResolveSuggestions={(filter: string, selectedItems?: ITag[]): ITag[] | PromiseLike<ITag[]> => {
                    let tagsToShow: string[] = [];
                    const filteredTags = possibleTags.filter(t => !selectedItems?.map(t => t.key).includes(t.Tag) && t.Tag.toLowerCase().startsWith(filter.toLowerCase()));
                    if (filteredTags.length > 0) {
                        tagsToShow = filteredTags.map(t => t.Tag);
                    }
                    else {
                        tagsToShow = [filter];
                    }
                    return tagsToShow.map(t => ({ key: t, name: t }));
                }}
                onEmptyResolveSuggestions={(selectedItems) => possibleTags.map(t => t.Tag).filter(t => !selectedItems?.map(t => t.key).includes(t)).map(t => ({ name: t, key: t })) || []}
                onChange={(selectedItems) => {
                    setUpdatedItem({ ...updatedItem, Tags: selectedItems?.map(t => t.key.toString()) || [] });
                }} /></Stack>}
    </Panel>
};

export default TagConfigurationPanel;